// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
/**
 * ResultType indicates if this is a person or thread match.
 */
export var ResultType;
(function (ResultType) {
    ResultType["RESULT_TYPE_UNSPECIFIED"] = "RESULT_TYPE_UNSPECIFIED";
    ResultType["RESULT_TYPE_THREAD"] = "RESULT_TYPE_THREAD";
    ResultType["RESULT_TYPE_PERSON"] = "RESULT_TYPE_PERSON";
})(ResultType || (ResultType = {}));
export var ResultType_index;
(function (ResultType_index) {
    ResultType_index[ResultType_index["RESULT_TYPE_UNSPECIFIED"] = 0] = "RESULT_TYPE_UNSPECIFIED";
    ResultType_index[ResultType_index["RESULT_TYPE_THREAD"] = 1] = "RESULT_TYPE_THREAD";
    ResultType_index[ResultType_index["RESULT_TYPE_PERSON"] = 2] = "RESULT_TYPE_PERSON";
})(ResultType_index || (ResultType_index = {}));
/**
 * SMSSearchService is the service that provides search functionality for sms.
 */
export const SMSSearchService = {
    /**
     * Search returns a list of contacts and threads that have messages matching the query.
     */
    Search(fn, req) {
        return fn(`/sms/search/v2?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ListSearches returns a list of searches that have been performed for a user.
     */
    ListSearches(fn, req) {
        return fn(`/sms/search/v2/searches?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * LogSearch creates a new search history record.
     */
    LogSearch(fn, req) {
        return fn(`/sms/search/v2/searches`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * DeleteSearch deletes a search that has been performed for a user.
     */
    DeleteSearch(fn, req) {
        try {
            fm.validateUrlParam(req["searchId"], "searchId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/sms/search/v2/searches/${req["searchId"]}?${fm.renderURLSearchParams(req, ["searchId"])}`, { method: "DELETE" });
    },
};
